import { Component } from "@angular/core";

@Component({
  selector: 'pg-painel-ofertas-cadastro',
  templateUrl: './painel-ofertas-cadastro.page.html',
  styleUrls: ['./painel-ofertas-cadastro.page.scss']
})
export class PainelOfertasCadastroPage {

  constructor(){
  }
}